exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-responsive[data-v-75db000c]{\n    padding: 0px;\n    transform: translateY(-0%);\n}\n", ""]);

// exports
